<template>
  <div id="form-centro">
    <v-btn color="lime darken-2" dark class="mb-3" @click="volver()">
      <v-icon right dark>arrow_back_ios</v-icon>Volver
    </v-btn>
    <v-container grid-list-xl>
      <v-card>
        <v-toolbar color="white" dark flat dense cad>
          <v-toolbar-title class="indigo--text"
            >Observaciones de centro</v-toolbar-title
          >
        </v-toolbar>
        <v-layout>
          <v-flex xs12 md12>
            <!-- INICIO DATOS DE CENTRO -->
            <grid-observacion :key="gridObservacion"></grid-observacion>
          </v-flex>
        </v-layout>
        <template>
          <v-card v-if="show == true" :key="cardObservacion">
            <v-layout>
              <v-flex xs12 md12>
                <v-toolbar color="white" dark flat dense cad>
                  <v-toolbar-title class="indigo--text"
                    >Evidencia centro</v-toolbar-title
                  >
                </v-toolbar>
                <v-layout>
                  <v-container grid-list-xl>
                    <v-toolbar color="white" dark flat dense cad>
                      <v-toolbar-title class="indigo--text"
                        >Observaciones</v-toolbar-title
                      >
                    </v-toolbar>
                  </v-container>
                  <v-flex xs12 md1></v-flex>
                  <v-spacer></v-spacer>
                  <v-flex xs12 md4>
                    <v-select
                      v-model="estadoCentroValue"
                      :items="estadoCentroSelect"
                      item-text="nombre"
                      item-value="code"
                      :error-messages="rolSelectErrors"
                      label="Estado Centro"
                      :box="tipeView == 'consulta'"
                      :readonly="tipeView == 'consulta'"
                      @input="$v.estadoCentroValue.$touch()"
                      @blur="
                        tipeView == 'crear'
                          ? $v.estadoCentroValue.$touch()
                          : null
                      "
                    ></v-select>
                  </v-flex>
                </v-layout>
                <v-container grid-list-xl>
                  <v-layout justify-center>
                    <v-flex xs12 md1></v-flex>
                    <v-flex>
                      <template>
                        <div id="backup-data">
                          <v-layout>
                            <v-flex lg12>
                              <v-card>
                                <v-form>
                                  <v-flex xs12 md1></v-flex>
                                  <!-- OBSERVACIONES -->
                                  <v-flex xs12>
                                    <v-textarea
                                      v-model="observacion"
                                      :error-messages="observacionErrors"
                                      label="Observacion"
                                      :readonly="tipeView == 'consulta'"
                                      :box="tipeView == 'consulta'"
                                      @input="$v.observacion.$touch()"
                                      @blur="
                                        tipeView == 'crear'
                                          ? $v.observacion.$touch()
                                          : null
                                      "
                                    ></v-textarea>
                                  </v-flex>
                                  <v-flex xs12 md1></v-flex>
                                </v-form>
                              </v-card>
                            </v-flex>
                          </v-layout>
                        </div>
                      </template>
                      <!-- TERMINO DATOS DE BACKUP -->
                    </v-flex>
                    <v-flex xs12 md1></v-flex>
                  </v-layout>
                </v-container>
                <v-container grid-list-xl>
                  <v-toolbar color="white" dark flat dense cad>
                    <v-toolbar-title class="indigo--text"
                      >Documentacion asociada</v-toolbar-title
                    >
                  </v-toolbar>
                </v-container>
                <v-layout v-if="tipeView != 'consulta'">
                  <v-flex xs12 md1></v-flex>
                  <v-flex>
                    <v-select
                      v-model="tipoEvidenciaValue"
                      :items="tipoEvidenciaSelect"
                      item-text="nombre"
                      item-value="id"
                      :error-messages="rolSelectErrors"
                      label="Tipo Evidencia"
                      :box="
                        tipeView == 'crear'
                          ? false
                          : isDisabled || disableonmodifica || vistaconsulta
                      "
                      :readonly="
                        tipeView == 'crear'
                          ? false
                          : isDisabled || disableonmodifica || vistaconsulta
                      "
                      @change="tipoDocumentoEvidencia()"
                      @input="$v.tipoEvidenciaValue.$touch()"
                      @blur="
                        tipeView == 'crear'
                          ? $v.tipoEvidenciaValue.$touch()
                          : null
                      "
                    ></v-select>
                  </v-flex>
                  <v-flex xs12 md1></v-flex>
                  <v-flex>
                    <br />
                    <!-- ADJUNTOS -->
                    <data-adjunto
                      :key="ObservacionAdjunto"
                      :tipeArchive="tipeArchive"
                    >
                    </data-adjunto>
                  </v-flex>
                  <v-flex>
                    <v-btn
                      :loading="loading"
                      color="primary"
                      dark
                      class="mb-2"
                      @click="saveDocument"
                      >Cargar
                      <v-icon right dark>add_circle_outline</v-icon></v-btn
                    >
                  </v-flex>
                  <v-flex xs12 md1></v-flex>
                </v-layout>
                <v-layout>
                  <v-flex xs12 md12>
                    <!-- INICIO DATOS DE CENTRO -->
                    <grid-evidencia :key="gridEvidencia"></grid-evidencia>
                  </v-flex>
                </v-layout>
                <!-- TERMINO DATOS DE CENTRO -->
              </v-flex>
              <v-flex xs12 md1></v-flex>
            </v-layout>
            <!-- INICIO DATOS DE BACKUP -->
            <v-card-actions class="pb-3">
              <v-spacer></v-spacer>
              <v-btn
                v-if="tipeView != 'consulta'"
                :loading="loading"
                color="primary"
                @click="saveObservacion()"
                >Guardar <v-icon right dark>save</v-icon></v-btn
              >
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </template>
      </v-card>
    </v-container>
  </div>
</template>
<script>
import { validationMixin } from "vuelidate";
import { required, email } from "vuelidate/lib/validators";
import { misRoles } from "@/mixins/roles.js";
import { misMixins } from "@/mixins/myMixing.js";
import axios from "axios";
import AlertEmpty from "@/views/ui/AlertEmpty.vue";
import DataCentro from "@/modules/aplicacion/views/centros/CentroData.vue";
import DataPersonaEncargado from "@/modules/aplicacion/views/centros/PersonaData.vue";
import DataPersonaBackup from "@/modules/aplicacion/views/centros/PersonaData.vue";
import GridObservacion from "@/modules/aplicacion/views/centros/GridObservacion.vue";
import GridEvidencia from "@/modules/aplicacion/views/centros/GridEvidencia.vue";
import DataAdjunto from "@/components/AdjuntoData.vue";
export default {
  name: "FormObservacion",
  components: {
    AlertEmpty,
    DataCentro,
    DataPersonaEncargado,
    DataPersonaBackup,
    GridObservacion,
    GridEvidencia,
    DataAdjunto,
  },
  mixins: [misRoles, misMixins, validationMixin],
  props: {
    rowsTable: "",
    titleViewCenter: "",
  },

  data() {
    return {
      loading: false,
      alertaRecibidos: false,
      dialog: false,
      visibleNew: false,
      userlogged: "",
      estadoCentroValue: "",
      estadoCentroSelect: [],
      tipoEvidenciaValue: "",
      tipoEvidenciaSelect: [],
      estadosCentro: "",
      tiposEvidencia: "",
      observacion: "",
      idCentro: "",
      cardObservacion: 0,
      gridObservacion: 10,
      gridEvidencia: 20,
      ObservacionAdjunto: 30,
      tipeView: "",
      show: Boolean,
    };
  },

  validations: {
    apellido: { required }, //maxLength: maxLength(10)
    nombre: { required },
    username: { required, email },
    tipoUsuarioValue: { required },
    rolUsuarioValue: { required },
    //contratoValue: this.tipeView == 'crear' { required } // ESTE CAMPO SE USA CUANDO SE CREA UN USUARIO DESDE CONFIGURACION
  },

  created() {
    this.idCentro = this.$route.params.idCentro;
    this.userlogged = this.$store.getters.userLogged.tipo;
    this.tipeView = this.$route.params.tipeView;
    this.show = false;

    if (this.tipeView == "crear") {
      this.loadDataEstadosCentro();
      this.loadDataTiposEvidencia();
    }
    if (this.tipeView == "modifica") {
      this.loadDataEstadosCentro();
      this.loadDataTiposEvidencia();
    }
  },

  mounted() {},
  computed: {},
  methods: {
    tipoDocumentoEvidencia() {
      if (this.tipoEvidenciaValue == "FOTOGRAFIA") {
        this.tipeArchive = ".jpg,.png";
      }
      if (this.tipoEvidenciaValue == "VIDEO") {
        this.tipeArchive = ".avi,.flv,.mpeg";
      }
      if (this.tipoEvidenciaValue == "DOCUMENTO") {
        this.tipeArchive = ".txt,.pdf,.doc";
      }
      if (this.tipoEvidenciaValue == "OTROS") {
        this.tipeArchive = "*";
      }
      this.reloadObservacionAdjunto();
    },

    getEstadoName(estadoId) {
      let encontrar = this.estadoCentroSelect.find(function (x) {
        return x.code == estadoId;
      });
      return encontrar.nombre;
    },

    reloadGridObservacion() {
      this.gridObservacion += 11;
    },

    reloadObservacion() {
      this.cardObservacion += 1;
      this.show = true;
    },
    reloadEvidencia() {
      this.gridEvidencia += 21;
    },

    reloadObservacionAdjunto() {
      this.ObservacionAdjunto += 31;
    },

    async loadEstadosCentro() {
      return await axios
        .get("/centro/estados")
        .then((response) => {
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
          return [];
        });
    },
    async loadDataEstadosCentro() {
      this.estadosCentro = await this.loadEstadosCentro();
      let est = [];
      this.estadosCentro.forEach(function (e) {
        est.push({ nombre: e.descripcion, code: e.id });
      });
      this.estadoCentroSelect = est;
      return;
    },

    async loadTiposEvidencia() {
      return await axios
        .get("/centro/tiposEvidencia")
        .then((response) => {
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
          return [];
        });
    },
    async loadDataTiposEvidencia() {
      this.tiposEvidencia = await this.loadTiposEvidencia();
      let tip = [];
      this.tiposEvidencia.forEach(function (t) {
        tip.push({ nombre: t.descripcion, code: t.id });
      });
      this.tipoEvidenciaSelect = tip;
      return;
    },

    saveDocument() {
      this.loading = true;
      if (
        this.base64Value != null &&
        this.base64Value != "" &&
        this.base64Value !== undefined
      ) {
        let subProceso = this.$store.getters.subProTabSelectedStored;
        let idContrato = this.$store.getters.contratoStored;
        let base64EncodedStr = this.base64Value;
        let proceso = this.$store.getters.proSelectedStored;
        this.body = {
          sTipoEvidencia: this.tipoEvidenciaValue,
          idCentroObservacion: this.idCentro,
          filename: this.filenameValue,
          documento: base64EncodedStr,
          idContrato: idContrato,
        };
        axios
          .post("/centro/evidencia/temporal/create", this.body)
          .then((res) => {
            this.resp = res.data;
            window.getApp.$emit("APP_SAVE");
            this.loading = false;
          })
          .then((rel) => {
            this.reloadEvidencia();
            this.clearDocument();
          })
          .catch((error) => {
            if (error) {
              console.log(error.response.data);
              window.getApp.$emit(
                "ERROR_EXCEPTION",
                error.response.data.message
              );
              this.loading = false;
            }
            return [];
          });
      } else {
        window.getApp.$emit("APP_ADMIN_FIELD");
        this.loading = false;
      }
    },

    saveObservacion() {
      this.loading = true;
      let subProceso = this.$store.getters.subProTabSelectedStored;
      let idUserLogged = this.$store.getters.userLogged.id;
      let idContrato = this.$store.getters.contratoStored;
      let centroId = this.$route.params.idCentro;

      this.body = {
        // -----
        idCentro: centroId,
        observaciones: this.observacion,
        estado: this.getEstadoName(this.estadoCentroValue), //"OBSERVADO",
        idContrato: idContrato,
      };

      axios
        .post("/centro/observaciones", this.body)
        .then((response) => {
          this.resp = response.data;
          this.loading = false;
          window.getApp.$emit("APP_SAVE");
          this.saveEvidencia();
          this.volver();
        })
        .catch((error) => {
          if (error) {
            console.log(error.response.data);
            window.getApp.$emit("ERROR_EXCEPTION", error.response.data.message);
            this.loading = false;
          }
        });
    },

    saveEvidencia() {
      let centroId = this.$route.params.idCentro;
      let idContrato = this.$store.getters.contratoStored;
      axios
        .get("/centro/evidencia/create/" + centroId + "/" + idContrato)
        .then((response) => {
          this.resp = response.data;
          this.loading = false;
          // window.getApp.$emit("APP_SAVE");

          // this.volver();
        })
        .catch((error) => {
          if (error) {
            console.log(error.response.data);
            window.getApp.$emit("ERROR_EXCEPTION", error.response.data.message);
            // this.loading = false;
          }
        });
      // this.volver()
    },
    clearDocument() {
      this.tipoEvidenciaValue = "";
      this.reloadObservacionAdjunto();
    },
    volver() {
      setTimeout(() => {
        this.$router.push({
          name: "ProcesoAplicacion",
        });
      }, 1000);
    },
  },
};
</script>
